import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OMSPurchasesResponse, SmartBasketRequestObject, ProductGridEndpointResponse, ProductGridEndpointRequestObject } from '../models/endpoints/purchases-endpoint.model';
import { Observable } from 'rxjs';
import { CommonService } from './common.service';
import { UserInfoService } from './user-info.service';

@Injectable({
  providedIn: 'root'
})
export class PurchasesEndpointService {
  private readonly endpointPaths = {
    smartbasket: '/purchasehistory/smartbasket/',
    productgrid: '/purchasehistory/product-grid'
  };

  constructor(private _httpClient: HttpClient, private _commonService: CommonService, private _userInfoService: UserInfoService) {}

  public fetchPurchasesGridEndpointData(data: ProductGridEndpointRequestObject): Observable<ProductGridEndpointResponse> {
    const {apimKey, request, basePath} = data;
    const httpOptions = this.createPurchasesGridEndpointHttpOptions(apimKey);
    return this._httpClient.post<ProductGridEndpointResponse>(basePath + this.endpointPaths.productgrid, request, httpOptions);
  }

  private createPurchasesGridEndpointHttpOptions(apimKey: string): { headers: HttpHeaders } {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'platform': 'web',
        'Ocp-Apim-Subscription-Key': apimKey
      })
    }
    return httpOptions;
  }



  public fetchSmartBasketResponse(data: SmartBasketRequestObject): Observable<OMSPurchasesResponse> {
    const httpOptions = this.createHttpOptions(data?.headers);
    const params = this.createSmartBasketParams(data?.filterParams, data?.banner);
    const baseUrl = this.createBaseSmartBasketUrl(data?.basePath, data?.hhid, params);
    const finalUrl = this._commonService.generateCBAUrl(baseUrl);

    return this._httpClient.get<OMSPurchasesResponse>(finalUrl, httpOptions);
  }

  private createHttpOptions(headers: { apimKey: string; bearerToken: string; pgm?: string }): { headers: HttpHeaders } {
    let httpHeaders = new HttpHeaders({
      'ocp-apim-subscription-key': headers.apimKey,
      'Authorization': `Bearer ${headers.bearerToken}`,
      'accept': 'application/json'
    });

    if (headers.pgm !== undefined) {
      httpHeaders = httpHeaders.set('pgm', headers.pgm);
    }

    return { headers: httpHeaders };
  }

  private createSmartBasketParams(filterParams: { branchId: string; pageNumber: number}, banner: string): string {
    return `availabilityCheck=true&storeId=${filterParams.branchId}&pageNo=${filterParams.pageNumber}&pageSize=50&excludeCartItems=true&placement=webquickadd&banner=${banner}`;
  }

  private createBaseSmartBasketUrl(basePath: string, hhid: string, params: string): string {
    return `${basePath}${this.endpointPaths.smartbasket}${hhid}?${params}`;
  }
}